import { Text, Group, MantineTheme, Select } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import type { CSSObject as CSS } from "@mantine/emotion";
import { FC } from "react";

type Props = {
  labelText: string;
  id?: string;
  placeHolder?: string;
  onChange?: CallableFunction;
  style?: CSS;
  isErrored?: string;
  errorMessage?: boolean;
  data: string[];
  value: string | null;
  searchable?: boolean;
  disabled?: boolean;
};

const InputSelect: FC<Props> = ({
  labelText,
  id,
  placeHolder,
  onChange,
  style: _style,
  isErrored,
  data,
  value,
  searchable = true,
  disabled = false,
  errorMessage,
}) => {
  const useStyles = createStyles((_theme: MantineTheme) => ({
    mainContainer: {},
    text: {
      color: "#3C4257",
      textAlign: "left",
    },
    inputField: {
      padding: "2px",
      height: "45px",
      width: "100%",
      marginBottom: "10px",

      //border:props.isErrored?'1px red solid':''
    },
    errorMessage: {
      color: "red",
      position: "relative",
      fontSize: "14px",
      top: "-10px",
      left: "0px",
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.mainContainer}>
      <Group justify="flex-start" mb={5}>
        <Text className={classes.text} component="label" htmlFor={id} size="sm">
          {labelText}
        </Text>
      </Group>
      <Select
        className={classes.inputField}
        placeholder={placeHolder}
        size="md"
        searchable={searchable}
        value={value}
        disabled={disabled}
        data={data}
        onChange={(e: string | null) => {
          if (onChange && e !== null) {
            onChange(e);
          }
        }}
        styles={{
          option: {
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          },
          input: {
            border: isErrored ? "1px solid #fa5252" : undefined,
          },
        }}
      />

      {isErrored && errorMessage && <div className={classes.errorMessage}>{isErrored}</div>}
    </div>
  );
};

export default InputSelect;
